import moment from 'moment';

export default function (value) {

    if (!value) return "N/A";

    var value_ = new moment(value);

    var now_ = new moment();

    if (now_.diff(value_, "hours", true) < 1) return now_.diff(value_, "minutes") + " phút trước";
    if (now_.diff(value_, "days", true) < 1) return now_.diff(value_, "hours") + " giờ trước";

    return value_.format("DD/MM/YYYY HH:mm");
}





// WEBPACK FOOTER //
// ./src/filters/convertToLabelFilter.js